<template>
  <div id="join_us" v-if="loaded">
    <header class="join-hero-header">
      <div class="top-bar">
        <a :href="host" class="brand">Best Phone</a>
        <a :href="host" class="clean_link go_back_home">{{ words.go_back_home }}</a>
      </div>

      <h1 class="hero-title"> כאן מתחילים...</h1>
      <p class="hero-subtitle">חיבור מהיר של המספר או החבילה שלך</p>
    </header>

    <!-- מעטפת מעוצבת צפה -->
    <div class="join-shell">
      <main class="join-main" id="form" :class="'step_' + step">
        <FirstStep
          v-if="step === 1"
          @loadData="loadData"
          @returnStep="step--"
          @setActiveNumber="setActiveNumber"
          @toggleProd="toggleProd"
          :numbers_overseas_info="numbers_overseas_info"
          :numbersInfo="numbersInfo"
          :step="step"
          :numbers="numbers"
          @addNewNumber="addNewNumber"
          @addUsNumber="addUsNumber"
          @getNumbers="getNumbers"
          @numbersValidation="numbersValidation"
          :activeNumber="+activeNumber"
        />
        <SecondStep
          v-if="step === 2"
          @returnStep="step--"
          :numbersInfo="numbersInfo"
          :parentForm="form"
          :step="step"
          :numbers="numbers"
          @saveData="saveCartData"
        />
        <ThirdStep
          v-if="step === 3"
          @returnStep="step--"
          :numbersInfo="numbersInfo"
          :parentForm="form"
          :step="step"
          :numbers="numbers"
          @saveData="saveCartData"
        />
        <FourthStep
          v-if="step === 4"
          :skipPay="skipPay"
          @goToStep="goToStep"
          :email="form.email || ''"
          :phone="form.phone_number || ''"
          @returnStep="step--"
          :numbersInfo="numbersInfo"
          :step="step"
          :numbers="numbers"
          @saveData="saveCartData"
        />
        <FifthStep
          v-if="step === 5"
          :skipPay="skipPay"
          @goToStep="goToStep"
          @returnStep="step--"
          :numbersInfo="numbersInfo"
          :step="step"
          :numbers="numbers"
          @saveData="saveCartData"
        />
      </main>
         <!-- @payment-details="setPaymentDetails" -->

      <!-- עגלה מעוצבת כסרגל צדדי (Sidebar) -->
      <aside class="join-summary" id="cart" :class="cartOpen ? 'open' : 'close'">
        <div class="cart-header">
          <h2 class="join-summary-title">{{ words.cart_title }}</h2>
          <template v-if="isMobile() || isCartMobile()">
            <div class="close-icon" @click="cartOpen = !cartOpen">
              <font-awesome-icon icon="fa fa-times" />
            </div>
          </template>
        </div>

        <ul class="summary-list">
          <template v-if="numbersInfo">
            <li v-for="num in numbersInfo" :key="num.id" class="summary-item active">
              <div class="item-info">
                <div class="trash-box" v-if="numbersInfo.length > 1" @click="removeNumber(num)">
                  <font-awesome-icon icon="fa fa-trash-alt" />
                </div>
                <div class="trash-box empty" v-else></div>

                <div class="details" v-if="num.phone_number && num.phone_number.length > 3">
                  <div class="phone-num bold" v-if="num.phone_number.length < 12">
                    {{ num.phone_number }}
                    <a class="change-link" @click="changeNumber(num)">{{ words.change_number }}</a>
                  </div>
                  <div class="status-tag">
                    {{ !num.has_number ? 'מספר חדש' : 'מספר קיים' }}
                  </div>
                </div>

                <div class="price-box bold add_ils">
                  {{ num.total_price }}
                </div>
              </div>
            </li>
          </template>
        </ul>

        <div class="join-summary-item" v-if="step === 5 && !isAgentLoggedIn">
           <span>* החיוב הראשון שונה מהמחיר החודשי וכולל חיוב יחסי עבור החודש הנוכחי ודמי הצטרפות בסך 50 ₪.</span>
        </div>

       <!-- <div class="join-summary-item" v-if="step === 5">
          <span>סה"כ לתשלום</span>
          <span class="price add_ils">{{ paymentTotal }}</span>
        </div>
        -->

        <div class="join-summary-total">
          <div class="total-label bold">{{ words.total }}</div>
          <div class="total-price main_color bold">
            <span class="deleted_price add_ils" v-if="total < deletedPrice">{{ deletedPrice }}</span>
            <span class="add_ils">{{ total }}</span>
            <span class="per-month">{{ words.to_month }}</span>
          </div>
        </div>
      </aside>
    </div>

    <div v-if="!isMobile()" id="back_image">
      <div id="white_logo"></div>
    </div>
  </div>
</template>

<script>
import FirstStep from '@/components/FirstStep.vue'
import SecondStep from '@/components/SecondStep.vue'
import ThirdStep from '@/components/ThirdStep.vue'
import FourthStep from '@/components/FourthStep.vue'
import FifthStep from '@/components/FifthStep.vue'

export default {
  components: { FirstStep, SecondStep, ThirdStep, FourthStep, FifthStep },
  data() {
    return {
      host: location.host.slice(0, 2) == "en" ? 'https://en.bestphonekosher.com' : 'https://bestphonekosher.com',
      isAgentLoggedIn: document.cookie.split(';').some(cookie => cookie.trim().startsWith('CRM_agent_id=')),
      selectedIds: '',
      activeNumber: 0,
      step: 1,
      deletedPrice: 0,
      loaded: false,
      cartOpen: !this.isMobile(),
      numbersInfo: [],
      total: 0,
// paymentTotal: 0,
      otpType: "SMS",
      otpPhone: "",
      form: {},
      numbers: [],
      numbersUs: [],
      skipPay: false,
      numbers_overseas_info: [],
      numberOfSteps: 5
    }
  },
  mounted() {
    this.loadData();
    this.getNumbers();
  },
  computed: {
    words() {
      return this.$store.state.words;
    },
    bgImg() {
      if (this.isMobile()) return 'https://primemobile.co.il/themes/WID/images/step_2.jpg';
      else return 'https://primemobile.co.il/themes/WID/images/step_' + (this.step <= 5 ? this.step : 2) + '.jpg'
    }
  },
  methods: {
    /* eslint-disable */
    loadData(activeNumber = false, dontAdd = false, dontRefresh = false) {
      this.loaded = false;
      let plan = '';
      if(this.$route.query.plan && this.$route.query.plan != '') {
        plan = this.$route.query.plan;
        this.$router.replace({'query': null});
      }

      this.api({ action: 'cart/get', data: { plan: plan }, method: 'post' }, (data) => {
        if (this.loaded && !dontAdd) {
          this.numbersValidation();
        }

        if (data.data.items === undefined || data.data.items.length == 0) this.addNewNumber();
        else {
          let numbers = this.parseNumbers(data.data.items);
          this.numbersInfo = numbers;
          if (!dontRefresh) this.activeNumber = this.numbersInfo[0].id;
          else this.activeNumber = dontRefresh;
        }

        if (activeNumber !== false) this.activeNumber = activeNumber;
        this.numbers_overseas_info = data.data.numbers_overseas_info;
        this.form = data.data.order_data;
        this.total = data.data.total_price;
        this.deletedPrice = data.data.total_price_deleted;
      });

      this.loaded = true;
    },

    sendOtp(item = false) {
      if(item != false) {
        if(item.type && item.type != '') this.otpType = item.type;
        if(item.phoneNumber && item.phoneNumber != '') this.otpPhone = item.phoneNumber;
      }

      this.api({ action: 'api/send_otp', data: { number: this.otpPhone, type: this.otpType } }, (data) => {
        if(data.data.error && data.data.error != "") {
          this.activateError(data.data.error);
        } else {
          if(data.data) {
            this.step = 8;
          } else {
            this.activateError(this.$store.state.words.goto_help);
          }
        }
      });
    },

    goToStep(step) {
      this.step = step > 0 ? step : 1;
    },

  // setPaymentDetails(details) {
   //   this.paymentTotal = details.total_price;
   // },
   

    toggleProd(num, prod) {
      this.api({ action: 'cart/add_item', data: { item_id: prod.id, id: num.id } }, async (data) => {
        if(data.data?.error && data.data?.error != "") this.activateError(data.data.error)
        else {
          this.numbersValidation(false, num.id);
        }
      })
    },

    getNumbers() {
      this.api({ action: 'cart/get_numbers', method: 'post' }, (data) => {
        if (data.data.error && data.data.error != '')
          this.activateError(data.data.error)
        else this.numbers = data.data
      })
    },

    addUsNumber(item) {
      this.api({ action: 'cart/add_us_number', data: { plan: item }, method: 'post' }, (data) => {
        if (data.data.error && data.data.error != '')
          this.activateError(data.data.error)
        else {
          this.loadData(false, true, item.id);
        }
      })
    },

    removeNumber(num) {
      this.api({ action: 'cart/remove_number', data: { phone_number: num.phone_number, id: num.id } }, () => {
        this.loadData(false, true);
      });
    },

    addNewNumber() {
      this.getNumbers()
      this.api(
        { action: 'cart/add_number', method: 'post', data: { id: 'new' } },
        (data) => {
          if (data.data.error && data.data.error != '') {
            this.activateError(data.data.error)
          } else {
            this.loadData(data.data)
          }
        }
      )
    },

    numbersValidation(next = false, numberId = false) {
      for (let i in this.numbersInfo) {
        if (this.numbersInfo[i].phone_number.length < 10) {
          this.activeNumber = this.numbersInfo[i].id;
          this.numbersInfo[i].alert = true;
          return false
        }
      }

      this.api({ action: 'cart/numbers_validation', data: { numbers_array: this.numbersInfo } },
        (data) => {
          if (data.data?.error && data.data.error != '')
            this.activateError(data.data.error)
          else {
            if (data.data.data && !data.data.data) {
              for (let i in this.numbersInfo) {
                if (this.numbersInfo[i].id == data.data.id_false) {
                  this.numbersInfo[i].alert = true
                }
              }
              return false
            }
            if (next) {
              this.step++
              window.scrollTo(0, 0)
            }
            if (numberId !== false) {
              this.loadData(false, false, numberId)
            }
          }
        }
      )
      return true
    },

    setActiveNumber(id) {
      this.activeNumber = id;
    },

    saveCartData(formData, dontMoveStep = false) {
      if (this.step == 3 && formData.community_id <= 0) {
        this.activateError(this.words.choose_community)
        return false
      }

      if(formData) {
        this.form = { ...this.form, ...formData };
      }
      this.$store.commit('setIsLoading', { isLoading: true })

      this.api(
        {
          action: 'api/user_exist',
          data: { id_card: this.form.id_card, email: this.form.email },
        },
        (data) => {
          if (data.data.error && data.data.error != '') {
            this.activateError(data.data.error)
            return this.$store.commit('setIsLoading', { isLoading: false })
          } else {
            if (data.data.exist) {
              this.api({ action: 'cart/add_cart_data', data: formData })
              this.$store.commit('setIsLoading', { isLoading: false })
              this.$swal
                .fire({
                  icon: 'info',
                  title: `<h2 class="second_step_title" style="font-size: 24px">${this.words.user_exists_text}</h2>`,
                  showDenyButton: true,
                  showCancelButton: false,
                  confirmButtonText: 'מעבר לאזור האישי',
                  denyButtonText: 'שימוש בכתובת מייל אחרת',
                  customClass: { container: 'second_step_swal' }
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    document.location = 'https://prime.roamability.com/';
                  } else if (result.isDenied) {
                    this.step = 2
                  }
                })
            } else {
              this.api(
                { action: 'cart/add_cart_data', data: formData },
                () => {
                  if (!dontMoveStep) {
                    this.step++
                    window.scrollTo(0, 0)
                    this.$store.commit('setIsLoading', { isLoading: false })
                  }
                }
              )
            }
          }
        }
      )
    },

    parseNumbers(items) {
      for(let i in items) {
        items[i].alert = false
        if(items[i].has_number == "1") {
          items[i].has_number = true
        } else {
          items[i].has_number = false
        }
      }
      return items
    },

    changeNumber(num) {
      this.activeNumber = num.id
      this.step = 1
    },
  },
}
</script>